/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-10-19 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: Boolean,
  handleSubscribe: () => {}
};

type ComposedProps = Props & WithI18nProps;

class SpecialDiscountCodeExpiredModal extends Component<ComposedProps> {
  render() {
    const { active, handleSubscribe, i18n } = this.props;
    return (
      <Modal
        open={active}
        title={i18n.translate('AdminHTML.Subscription.SpecialDiscountCodeExpiredModal.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.subscribeNow'),
          onAction: handleSubscribe
        }}
        onClose={handleSubscribe}>
        <Modal.Section>
          <TextContainer>
            <div>
              <TextStyle>
                {i18n.translate(
                  'AdminHTML.Subscription.SpecialDiscountCodeExpiredModal.textStyle_1',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Subscription.SpecialDiscountCodeExpiredModal.textStyle_1_t1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </TextStyle>
            </div>
            <div>
              <TextStyle>
                {i18n.translate(
                  'AdminHTML.Subscription.SpecialDiscountCodeExpiredModal.textStyle_2',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate('AdminHTML.Common.Subscription.reSubscribe')}
                      </TextStyle>
                    )
                  }
                )}
              </TextStyle>
            </div>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

export default withI18n()(SpecialDiscountCodeExpiredModal);
